import { FC } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
  name: string;
  required?: boolean;
  options: string[];
}

export const InputCheckbox: FC<Props> = ({ name, required, options }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {options.map((option) => (
        <div
          className="form-checkbox"
          style={{ display: "block", marginBottom: ".6rem" }}
        >
          <input
            type="checkbox"
            value={option}
            id={`${name}-${option}`}
            style={{ marginRight: ".6rem" }}
            {...register(name, {
              validate: (value) => {
                if (required) {
                  if (!value || !value.length)
                    return "Por favor, selecione ao menos uma opção.";
                }
              },
            })}
          />
          <label htmlFor={`${name}-${option}`}>{option}</label>
        </div>
      ))}
      {errors?.[name] && (
        <span className="field-error-message">
          {(errors[name]?.message as any) || "Inválido"}
        </span>
      )}
    </>
  );
};
